import 'whatwg-fetch';
import 'url-search-params-polyfill';
import config from 'libs/config';
import utils from 'libs/utils';
import { SessionSettings } from '@/plugins/security';

export default class FetchController {
  static async post (uri, body, credentials = 'include') {
    return fetch(uri, {
      method: 'post',
      credentials: credentials,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(body)
    }).then(response => {
      return response.json().then(json => {
        if (config.debug) {
          console.log('uri:', uri, 'response: ', json);
        }
        processResult(response, json);
        return response.ok ? json : Promise.reject(json);
      });
    });
  }
  static async postWithHeaders (uri, body, headers, credentials = 'include') {
    if(headers == null) headers = [];
    return fetch(uri, {
      method: 'post',
      credentials: credentials,
      headers: [
        ['Content-Type', 'application/json; charset=utf-8'],
        ...headers
      ],
      body: JSON.stringify(body)
    }).then(response => {
      return response.json().then(json => {
        if (config.debug) {
          console.log('uri:', uri, 'response: ', json);
        }
        processResult(response, json);
        return response.ok ? json : Promise.reject(json);
      });
    }).catch(error => {
    });
  }

  static async get (uri, body, credentials = 'include') {
    return fetch(uri, {
      method: 'get',
      credentials: credentials,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(body)
    }).then(response => {
      return response.json().then(json => {
        processResult(response, json);
        return response.ok ? json : Promise.reject(json);
      });
    });
  }

  static async getFile (uri, body, credentials = 'include') {
    return fetch(uri, {
      method: 'get',
      credentials: credentials,
      headers: {
        // 'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      },
      body: JSON.stringify(body)
    }).then(response => {
      return response.ok ? response.blob() : Promise.reject(response);
    });
  }

  static async postFile (uri, data, credentials = 'include') {
    return fetch(uri, {
      method: 'post',
      credentials: credentials,
      body: data
    }).then(response => {
      return response.ok ? response.json() : Promise.reject(response.json());
    });
  }

  static async put (uri, body, credentials = 'include') {
    return fetch(uri, {
      method: 'put',
      credentials: credentials,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(body)
    }).then(response => {
      return response.json().then(json => {
        return response.ok ? json : Promise.reject(json);
      });
    });
  }

  static async getWithHeaders (uri, body, headers, credentials = 'include') {
    return fetch(uri, {
      method: 'get',
      credentials: credentials,
      headers: [
        ['Content-Type', 'application/json; charset=utf-8'],
        ...headers
      ],
      body: JSON.stringify(body)
    }).then(response => {
      return response.json().then(json => {
        processResult(response, json);
        return response.ok ? json : Promise.reject(json);
      });
    });
  }
}

const processResult = (response, json) => {
  if (!response.ok) {
    // error
    if (response.status === 403) {
      // forbidden
      if (json && !json.Authenticated) {
        // not authenticated -> redirect to login
        utils.RedirectToLogin();
      }
    }
  } else {
    SessionSettings.Refresh();
  }
};